/**
 * @generated SignedSource<<8a551e5606b6f4785f0875c71f51f5cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExpenseDetailsTable_project$data = {
  readonly id: string;
  readonly projectFirstDateYear: number | null;
  readonly projectFirstDateMonth: number | null;
  readonly projectFirstDateDay: number | null;
  readonly projectLastDateYear: number | null;
  readonly projectLastDateMonth: number | null;
  readonly projectLastDateDay: number | null;
  readonly " $fragmentType": "ExpenseDetailsTable_project";
};
export type ExpenseDetailsTable_project$key = {
  readonly " $data"?: ExpenseDetailsTable_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExpenseDetailsTable_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExpenseDetailsTable_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectFirstDateYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectFirstDateMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectFirstDateDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectLastDateYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectLastDateMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectLastDateDay",
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "31b88183ac2ba8aa74649705a66de3b3";

export default node;
